export enum SupportCaseDocumentType {
    Tcf, 
    Other
}